<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :title="`${!dialogType ? '确认' : '拒绝'}`"
    :visible.sync="dialogVisible"
    width="680px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh"
  >
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item v-if="dialogType" prop="reason" label="拒绝原因">
        <base-select-common
          ref="BaseSelectCommon"
          v-model="form.reason"
          width="320px"
          :type="3"
          title="拒绝原因"
        ></base-select-common>
      </el-form-item>
      <el-form-item v-if="mblIds.length === 1" label="提单信息">
        <div class="des">
          <el-row class="row">
            <p>
              <span class="label">提单号</span>
              <span class="data">{{ billData.mblNo }}</span>
            </p>
            <p>
              <span class="label">提单类型</span>
              <span class="data">{{
                billData.classification ? "分单" : "直单"
              }}</span>
            </p>
          </el-row>
          <el-row class="row">
            <p>
              <span class="label">提单件数</span>
              <span class="data">{{ billData.qty }}</span>
            </p>
            <p>
              <span class="label">重量</span>
              <span class="data">{{ billData.weightKgs }} KG</span>
            </p>
          </el-row>
          <el-row class="row">
            <p>
              <span class="label">方数</span>
              <span class="data">{{ billData.weightCbm }}</span>
            </p>
            <p>
              <span class="label">业务范畴</span>
              <span class="data">
                <span class="tips clearenceType">
                  {{ billData.clearenceType | formatterClearenceType }}</span
                  >
                <span class="tips pickUpType">{{
                  billData.pickUpType | formatterPickUpType
                }}</span></span
              >
            </p>
          </el-row>
        </div>
      </el-form-item>
      <el-row class="row">
        <el-form-item
          label="卸货港"
          style="margin-bottom: 20px"
          prop="dischargeHarbor">
          <el-select
            v-model="form.dischargeHarbor"
            filterable
            clearable
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="(item, $index) in dischargeHarborOptions"
              :key="$index"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="卸货港日期"
          style="margin-bottom: 20px"
          prop="dischargeHarborDate">
          <el-date-picker
            v-model="form.dischargeHarborDate"
            clearable
            type="datetime"
            placeholder="请选择到卸货港日期"
            style="width: 270px"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="操作" prop="operator">
          <el-select
            v-model="form.operator"
            multiple
            filterable
            clearable
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in operatorOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客服" prop="customer">
          <el-select
            v-model="form.customer"
            multiple
            filterable
            clearable
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="财务" prop="financer">
          <el-select
            v-model="form.financer"
            multiple
            filterable
            clearable
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in financerOptions"
              :key="item.id"
              :label="item.nameCH"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row v-if="!dialogType" class="row">
        <el-form-item
          v-if="mblIds.length !== 1 || billData.clearenceType"
          prop="clearanceMode"
          label="选择清关模式"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.clearanceMode"
            style="width: 270px"
            clearable
            placeholder="请选择清关模式"
            @change="form.supplierClearenceId = ''"
          >
            <el-option
              v-for="item in config.clearanceModesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="(mblIds.length !== 1 || billData.clearenceType) && form.clearanceMode !== 2"
          prop="invoiceReviewType"
          label="选择发票处理方式"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.invoiceReviewType"
            style="width: 270px"
            clearable
            placeholder="请选择发票处理方式"
          >
            <el-option
              v-for="item in config.invoiceReviewTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="(mblIds.length !== 1 || billData.clearenceType) && form.clearanceMode !== 2 && form.invoiceReviewType === 1"
          prop="tax"
          label="税金范围"
          style="margin-bottom: 20px"
        >
          <number-range
            v-model="form.tax"
            style="width: 270px"
            :min="0.01"
            :precision="2"
            :max="990000">
          </number-range>
        </el-form-item>
        <el-form-item
          v-if="mblIds.length !== 1 || billData.clearenceType"
          prop="supplierClearenceId"
          label="选择清关行"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.supplierClearenceId"
            style="width: 270px"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in clearenceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.clearanceMode === 2"
          prop="entryModel"
          label="选择生成模式"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.entryModel"
            style="width: 270px"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in entryModelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="billData.pickUpType"
          prop="supplierId"
          label="选择提货车行"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.supplierId"
            style="width: 270px"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in pickUpOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="billData.pickUpType === 2"
          prop="supplierUnstuffingId"
          label="拆柜供应商"
          style="margin-bottom: 20px"
        >
          <el-select
            v-model="form.supplierUnstuffingId"
            style="width: 270px"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in unstuffingOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="mblIds.length === 1" prop="dbValue" label="差异率">
          <div class="warn">
            {{ varianceRate }}
            <el-tooltip class="item" effect="dark" content="" placement="top">
              <div slot="content">
                提单重量与绑定订单重量差异率<br />超过设定值，提单确认时提示
              </div>
              <img class="suggest" src="@/assets/images/bill/suggest.png" />
            </el-tooltip>
          </div>
        </el-form-item> -->
        <el-form-item
          v-if="form.supplierClearenceId"
          prop="isSkipForecastReview"
          label=""
        >
          <el-checkbox
            v-model="form.isSkipForecastReview"
          >跳过预报审核<br /><span
            style="font-size: 12px"
          >(提单状态将跳转至预报已接受)</span
          ></el-checkbox
          >
        </el-form-item>
      </el-row>
      <el-row v-if="form.clearanceMode === 2">
        <el-form-item
          label="T11预报"
          style="margin-bottom: 20px"
        >
          <el-upload
            action="#"
            :show-file-list="false"
            :http-request="httpRequest"
          >
            <div class="upload">
              <img v-if="!file.name" src="@/assets/images/bill/upload-1.png" alt="" />
              <i v-else class="el-icon-circle-check" />
              选择文件上传
            </div>
          </el-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
const BaseSelectCommon = () => import('@/components/base/BaseSelectCommon.vue')
import { confirmMBLInfo, refuseMBL, confirmMBL, confirmT11Clearance } from '@/api/bill'
import { getSupplierDropDownList, getUserForType } from '@/api/system'
const NumberRange = () => import('@/components/base/NumberRange.vue')
import { mapGetters } from 'vuex'
import config from '@/utils/config'
export default {
  components: { BaseSelectCommon, NumberRange },
  filters: {
    formatterClearenceType(val) {
      if (val) {
        return '平台清'
      } else {
        return '自清'
      }
    },
    formatterPickUpType(val) {
      const obj = {
        0: '自提',
        1: '直送',
        2: '回仓'
      }
      return obj[val]
    }
  },
  props: {
    dialogType: {
      type: Number,
      default: 0 // 0确认 1拒绝
    },
    mblIds: {
      type: Array,
      default: () => []
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    priorityList: {
      type: Array,
      default: function() {
        return []
      }
    },
    shipperName: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config,
      refuseReason: '',
      form: {
        pickUpPriorityId: '',
        clearencePriorityId: '',
        supplierId: '',
        supplierClearenceId: '',
        supplierUnstuffingId: '',
        isSkipForecastReview: false,
        dischargeHarbor: '',
        dischargeHarborDate: '',
        operator: '',
        customer: '',
        financer: '',
        reason: '',
        clearanceMode: '',
        entryModel: '',
        invoiceReviewType: undefined,
        tax: [0, 999999]
      },
      rules: {
        reason: [
          { required: true, message: '请选择拒绝原因', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择提货车行', trigger: 'change' }
        ],
        supplierClearenceId: [
          { required: true, message: '请选择清关车行', trigger: 'change' }
        ],
        supplierUnstuffingId: [
          { required: true, message: '请选择拆柜供应商', trigger: 'change' }
        ],
        clearanceMode: [
          { required: true, message: '请选择清关模式', trigger: 'change' }
        ],
        entryModel: [
          { required: true, message: '请选择生成模式', trigger: 'change' }
        ],
        invoiceReviewType: [{ required: true, message: '请选择发票处理方式', trigger: 'change' }],
        tax: [{ required: true, message: '请选择税金范围', trigger: 'change' }]
      },
      billData: {},
      userOptions: [],
      pickUpOptions: [],
      clearenceList: [],
      // clearenceOptions: [],
      unstuffingOptions: [],
      entryModelOptions: [{
        value: 0,
        label: '按票'
      }, {
        value: 1,
        label: '按系统'
      }],
      file: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['addressBookOptions', 'shipDestinPortOptions', 'airDestinPortOptions']),
    operatorOptions() {
      return this.userOptions.filter((a) => [200, 2001, 266].includes(a.type))
    },
    financerOptions() {
      return this.userOptions.filter((a) =>
        [266, 201, 202, 203].includes(a.type)
      )
    },
    customerOptions() {
      return this.userOptions.filter((a) => [266, 1801, 180].includes(a.type))
    },
    clearenceTypeOptions() {
      return this.priorityList
        .filter((a) => a.type === 0)
        .map((item) => {
          return {
            value: item.id,
            label: item.contents
          }
        })
    },
    pickUpTypeOptions() {
      return this.priorityList
        .filter((a) => a.type === 1)
        .map((item) => {
          return {
            value: item.id,
            label: item.contents
          }
        })
    },
    varianceRate() {
      return `${(
        ((this.billData.weightKgs - this.billData.orderWeightKgs) /
          this.billData.weightKgs) *
        100
      ).toFixed(2)}%`
    },
    dischargeHarborOptions() {
      if (this.billData.type) {
        return this.airDestinPortOptions
      } else {
        return this.shipDestinPortOptions
      }
    },
    clearenceOptions() {
      return this.clearenceList.filter(a => a.clearanceModes?.includes(this.form.clearanceMode))
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.$store.dispatch('getAddressBookOptions', { type: -1 })
        try {
          if (this.mblIds.length === 1) {
            const res = await confirmMBLInfo({
              mblId: this.mblIds.join(',')
            })
            if (res.success) {
              this.billData = res.data
              this.form = {
                ...this.form,
                ...res.data,
                  dischargeHarbor: res.data.dischargeHarbor,
                  dischargeHarborDate: res.data.dischargeHarborDate
              }
              if (res.data.mblProductAny) {
                this.file = {
                  name: '已存在预报文件'
                }
              }
            } else {
              this.$message.error(res.errorMessage)
            }
          }
          const result1 = await getSupplierDropDownList({
            scopValue: 19,
            isActived: true
          })
          if (result1.success) {
            this.pickUpOptions = result1.data.sort((a, b) =>
              a.name.localeCompare(b.name)
            )
          } else {
            this.$message.error(result1.errorMessage)
          }
          const result2 = await getSupplierDropDownList({
            scopValue: 18,
            isActived: true
          })
          if (result2.success) {
            this.clearenceList = result2.data.sort((a, b) =>
              a.name.localeCompare(b.name)
            )
          } else {
            this.$message.error(result2.errorMessage)
          }
          const result3 = await getSupplierDropDownList({
            scopValue: 20,
            isActived: true
          })
          if (result3.success) {
            this.unstuffingOptions = result3.data.sort((a, b) =>
              a.name.localeCompare(b.name)
            )
          } else {
            this.$message.error(result3.errorMessage)
          }
          this.getUserForType()
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  mounted() {
    if (
      !(this.shipDestinPortOptions && this.shipDestinPortOptions.length > 0)
    ) {
      this.$store.dispatch('getShipDestinPortOptions')
    }
    if (!(this.airDestinPortOptions && this.airDestinPortOptions.length > 0)) {
      this.$store.dispatch('getAirDestinPortOptions')
    }
  },
  methods: {
    async getUserForType() {
      try {
        const res = await getUserForType({})
        if (res.success) {
          this.userOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$refs['form'].resetFields()
      this.$emit('cancel')
    },
    async httpRequest({ file }) {
      this.file = file
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          if (this.form.clearanceMode !== 2) {
            const operator = this.form.operator.map((a) => {
                return {
                  userId: a,
                  userName: this.operatorOptions.find(b => b.id === a).nameCH,
                  type: 0
                }
              })
              const customer = this.form.customer.map((a) => {
                return {
                  userId: a,
                  userName: this.customerOptions.find(b => b.id === a).nameCH,
                  type: 2
                }
              })
              const financer = this.form.financer.map((a) => {
                return {
                  userId: a,
                  userName: this.financerOptions.find(b => b.id === a).nameCH,
                  type: 1
                }
              })
            const params = {
              mblId: this.mblIds.join(','),
              supplierId: this.form.supplierId,
              supplierClearenceId: this.form.supplierClearenceId,
              dischargeHarbor: this.form.dischargeHarbor,
              dischargeHarborDate: this.form.dischargeHarborDate,
              users: [...operator, ...customer, ...financer]
            }
            if (!this.dialogType) {
              params.clearencePriorityId = this.form.clearencePriorityId
              params.pickUpPriorityId = this.form.pickUpPriorityId
              params.supplierUnstuffingId = this.form.supplierUnstuffingId
              params.isSkipForecastReview = this.form.isSkipForecastReview
              params.invoiceReviewType = this.form.invoiceReviewType
              params.clearanceMode = this.form.clearanceMode
              params.minTax = this.form.tax[0]
              params.maxTax = this.form.tax[1]
              this.loading = true
                const res = await confirmMBL(params)
              this.loading = false
                if (res.success) {
                  this.$message.success(res.errorMessage)
                  this.$emit('ok')
                  this.$refs[formName].resetFields()
                } else {
                  this.$message.error(res.errorMessage)
                }
              // }
            } else {
              if (!this.form.reason) {
                this.$message.error('未填写错误原因')
                return
              }
              params.reason = this.$refs.BaseSelectCommon.getValueLable(
                this.form.reason
              )
              this.loading = true
              const res = await refuseMBL(params)
              this.loading = false
              if (res.success) {
                this.$message.success(res.errorMessage)
                this.$emit('ok')
                this.$refs[formName].resetFields()
              } else {
                this.$message.error(res.errorMessage)
              }
            }
          } else {
            const formData = new FormData()
             formData.set('file', this.file)
            formData.set('mblId', this.mblIds.join(','),)
            formData.set('supplierClearenceId', this.form.supplierClearenceId)
            formData.set('supplierId', this.form.supplierId)
            formData.set('isSkipForecastReview', this.form.isSkipForecastReview)
            formData.set('entryModel', `${this.form.entryModel}`)
            try {
              this.loading = true
              const res = await confirmT11Clearance(formData)
              this.loading = false
               if (res.data.success) {
                this.$message.success(res.errorMessage)
                    this.$emit('ok')
                this.$refs[formName].resetFields()
                } else {
                    this.$message.error(res.data.errorMessage)
                }
            } catch (error) {
              console.log(error)
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  width: 560px;
  margin: 0 auto;
  .des {
    width: 520px;
    height: 120px;
    padding: 20px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #eeeeee;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    &:deep(.el-form-item):nth-child(2n) {
      margin-left: 15px;
    }
    p {
      width: 50%;
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
    & + .row {
      margin-top: 15px;
    }
    .label {
      display: inline-block;
      width: 59px;
    }
    .data {
      margin-left: 17px;
      color: #666666;
    }
    .tips {
      border-radius: 4px 4px 4px 4px;
      width: auto;
      height: 24px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      display: inline-block;
      padding: 0 4px;
      box-sizing: border-box;
      & + .tips {
        margin-left: 10px;
      }
    }
    .clearenceType {
      background:  rgb(18,88,188);
    }
    .pickUpType {
      background: #35ba83;
    }
    .warn {
      width: 270px;
      height: 40px;
      background: rgba(254, 69, 61, 0.1);
      border-radius: 4px 4px 4px 4px;
      font-size: 16px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #fe453d;
      line-height: 40px;
      text-align: center;
      position: relative;
    }
    .suggest {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 15px;
      top: 8px;
    }
  }
  &:deep(.el-checkbox__input) {
    vertical-align: 18px;
  }
}
:deep(.el-dialog__body) {
  padding-top: 0;
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
    .upload {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      box-sizing: border-box;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
</style>
